<p-confirmDialog key="station" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--School/Facility Selector-->
<div class="FacilityBorder">
	<!--School-->
	<label>School</label>
	<div style="margin-left: 10px">
		<caass-schoolselector [ShowAll]="true" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText" [Disabled]="IsLoading() == true">
		</caass-schoolselector>
	</div>

	<!--Facility-->
	<label>Facility</label>
	<div style="margin-left: 10px">
		<p-dropdown
			style="margin-left: 5px"
			[disabled]="IsLoading() == true"
			[options]="lstFacility"
			[(ngModel)]="SelectedFacility"
			optionLabel="FacilityName"
			[filter]="true"
			filterBy="FacilityName"
			[showClear]="false"
			placeholder="Select a Facility"
			(ngModelChange)="onFacilityChange($event)"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="SelectedFacility">
					<div class="form-control NoBorder" style="text-align: left" [style.color]="SelectedFacility.HasLocations == true ? 'Black' : 'Red'">
						{{ SelectedFacility.FacilityName }}
					</div>
				</div>
			</ng-template>
			<ng-template let-FacilityItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left" [style.color]="FacilityItem.HasLocations == true ? 'Black' : 'Red'">
						{{ FacilityItem.FacilityName }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>
	</div>
</div>

<!--Options to Show-->
<div class="ShowColOuterDiv">
	<h4>Columns to Show:</h4>

	<div class="ShowColGrid">
		<input id="ShowScanStation" name="ShowScanStation" type="checkbox" class="CHK" [(ngModel)]="ShowScanStation" />
		<label for="ShowScanStation">Station</label>

		<input id="ShowCurrentVersion" name="ShowCurrentVersion" type="checkbox" class="CHK" [(ngModel)]="ShowCurrentVersion" />
		<label for="ShowCurrentVersion">Version</label>

		<input id="ShowOutOfDateDesc" name="ShowOutOfDateDesc" type="checkbox" class="CHK" [(ngModel)]="ShowOutOfDateDesc" />
		<label for="ShowOutOfDateDesc">Out of Date</label>

		<input id="ShowFacilityID" name="ShowFacilityID" type="checkbox" class="CHK" [(ngModel)]="ShowFacilityID" />
		<label for="ShowFacilityID">Facility</label>

		<input id="ShowFacilityLocationID" name="ShowFacilityLocationID" type="checkbox" class="CHK" [(ngModel)]="ShowFacilityLocationID" />
		<label for="ShowFacilityLocationID">Location</label>

		<input id="ShowUseDefaultValues" name="ShowUseDefaultValues" type="checkbox" class="CHK" [(ngModel)]="ShowUseDefaultValues" />
		<label for="ShowUseDefaultValues">Use Default Values</label>

		<input id="ShowVisitorModeEnabled" name="ShowVisitorModeEnabled" type="checkbox" class="CHK" [(ngModel)]="ShowVisitorModeEnabled" />
		<label for="ShowVisitorModeEnabled">Visitor Scanning Enabled</label>

		<input id="ShowStudentModeEnabled" name="ShowStudentModeEnabled" type="checkbox" class="CHK" [(ngModel)]="ShowStudentModeEnabled" />
		<label for="ShowStudentModeEnabled">Student Scanning Enabled</label>

		<input id="ShowStaffModeEnabled" name="ShowStaffModeEnabled" type="checkbox" class="CHK" [(ngModel)]="ShowStaffModeEnabled" />
		<label for="ShowStaffModeEnabled">Staff Scanning Enabled</label>

		<input id="ShowOffenderLookupEnabled" name="ShowOffenderLookupEnabled" type="checkbox" class="CHK" [(ngModel)]="ShowOffenderLookupEnabled" />
		<label for="ShowOffenderLookupEnabled">Offender Lookup Enabled</label>

		<input id="ShowPanicButtonEnabled" name="ShowPanicButtonEnabled" type="checkbox" class="CHK" [(ngModel)]="ShowPanicButtonEnabled" />
		<label for="ShowPanicButtonEnabled">Panic Button Enabled</label>

		<input
			id="ShowConfirmPanicButtonEnabled"
			name="ShowConfirmPanicButtonEnabled"
			type="checkbox"
			class="CHK"
			[(ngModel)]="ShowConfirmPanicButtonEnabled"
		/>
		<label for="ShowConfirmPanicButtonEnabled">Confirm Panic Button Enabled</label>

		<input id="ShowPanicButtonText" name="ShowPanicButtonText" type="checkbox" class="CHK" [(ngModel)]="ShowPanicButtonText" />
		<label for="ShowPanicButtonText">Panic Button Text</label>

		<input id="ShowConfirmPanicButtonText" name="ShowConfirmPanicButtonText" type="checkbox" class="CHK" [(ngModel)]="ShowConfirmPanicButtonText" />
		<label for="ShowConfirmPanicButtonText">Confirm Panic Button Text</label>

		<input id="ShowPanicButtonTopicID" name="ShowPanicButtonTopicID" type="checkbox" class="CHK" [(ngModel)]="ShowPanicButtonTopicID" />
		<label for="ShowPanicButtonTopicID">Panic Button Topic (Staff App)</label>

		<input id="ShowSkipConfirmInfo" name="ShowSkipConfirmInfo" type="checkbox" class="CHK" [(ngModel)]="ShowSkipConfirmInfo" />
		<label for="ShowSkipConfirmInfo">Skip Confirm Info Page</label>

		<input id="ShowPhotoRequired" name="ShowPhotoRequired" type="checkbox" class="CHK" [(ngModel)]="ShowPhotoRequired" />
		<label for="ShowPhotoRequired">Photo Required</label>

		<input id="ShowSkipPhotoIfNotRequired" name="ShowSkipPhotoIfNotRequired" type="checkbox" class="CHK" [(ngModel)]="ShowSkipPhotoIfNotRequired" />
		<label for="ShowSkipPhotoIfNotRequired">Skip Photo Page If Not Required</label>

		<input id="ShowUseDriversLicensePhoto" name="ShowUseDriversLicensePhoto" type="checkbox" class="CHK" [(ngModel)]="ShowUseDriversLicensePhoto" />
		<label for="ShowUseDriversLicensePhoto">Use Driver's License Photo</label>

		<input id="ShowAllowExistingPhoto" name="ShowAllowExistingPhoto" type="checkbox" class="CHK" [(ngModel)]="ShowAllowExistingPhoto" />
		<label for="ShowAllowExistingPhoto">Allow Existing Photo</label>

		<input
			id="ShowForceRetakePhotoAfterXDays"
			name="ShowForceRetakePhotoAfterXDays"
			type="checkbox"
			class="CHK"
			[(ngModel)]="ShowForceRetakePhotoAfterXDays"
		/>
		<label for="ShowForceRetakePhotoAfterXDays">Retake Existing Photo After X Days</label>

		<input id="ShowSkipVisitorType" name="ShowSkipVisitorType" type="checkbox" class="CHK" [(ngModel)]="ShowSkipVisitorType" />
		<label for="ShowSkipVisitorType">Skip Visitor Type Page</label>

		<input id="ShowDefaultVisitorTypeID" name="ShowDefaultVisitorTypeID" type="checkbox" class="CHK" [(ngModel)]="ShowDefaultVisitorTypeID" />
		<label for="ShowDefaultVisitorTypeID">Default Visitor Type (If Skipping)</label>

		<input id="ShowSkipVisitee" name="ShowSkipVisitee" type="checkbox" class="CHK" [(ngModel)]="ShowSkipVisitee" />
		<label for="ShowSkipVisitee">Skip Visitee Page</label>

		<input id="ShowDefaultVisiteeID" name="ShowDefaultVisiteeID" type="checkbox" class="CHK" [(ngModel)]="ShowDefaultVisiteeID" />
		<label for="ShowDefaultVisiteeID">Default Visitee (If Skipping)</label>

		<input id="ShowSkipVisitReason" name="ShowSkipVisitReason" type="checkbox" class="CHK" [(ngModel)]="ShowSkipVisitReason" />
		<label for="ShowSkipVisitReason">Skip Visit Reason Page</label>

		<input id="ShowDefaultVisitReasonID" name="ShowDefaultVisitReasonID" type="checkbox" class="CHK" [(ngModel)]="ShowDefaultVisitReasonID" />
		<label for="ShowDefaultVisitReasonID">Default Visit Reason (If Skipping)</label>

		<input id="ShowSkipAdditionalNotes" name="ShowSkipAdditionalNotes" type="checkbox" class="CHK" [(ngModel)]="ShowSkipAdditionalNotes" />
		<label for="ShowSkipAdditionalNotes">Skip Additional Notes Page</label>

		<input id="ShowSkipSignature" name="ShowSkipSignature" type="checkbox" class="CHK" [(ngModel)]="ShowSkipSignature" />
		<label for="ShowSkipSignature">Skip Signature Page</label>

		<input
			id="ShowUseDriversLicenseSignature"
			name="ShowUseDriversLicenseSignature"
			type="checkbox"
			class="CHK"
			[(ngModel)]="ShowUseDriversLicenseSignature"
		/>
		<label for="ShowUseDriversLicenseSignature">Use Driver's License Signature</label>

		<input id="ShowPrinterName" name="ShowPrinterName" type="checkbox" class="CHK" [(ngModel)]="ShowPrinterName" />
		<label for="ShowPrinterName">Printer Name</label>

		<input id="ShowPrinterAlignTop" name="ShowPrinterAlignTop" type="checkbox" class="CHK" [(ngModel)]="ShowPrinterAlignTop" />
		<label for="ShowPrinterAlignTop">Printer Align Top</label>

		<input id="ShowPrinterAlignLeft" name="ShowPrinterAlignLeft" type="checkbox" class="CHK" [(ngModel)]="ShowPrinterAlignLeft" />
		<label for="ShowPrinterAlignLeft">Printer Align Left</label>

		<input id="ShowPrintStudentLatePasses" name="ShowPrintStudentLatePasses" type="checkbox" class="CHK" [(ngModel)]="ShowPrintStudentLatePasses" />
		<label for="ShowPrintStudentLatePasses">Print Student Late Passes</label>

		<input id="ShowPrintStudentEntryPasses" name="ShowPrintStudentEntryPasses" type="checkbox" class="CHK" [(ngModel)]="ShowPrintStudentEntryPasses" />
		<label for="ShowPrintStudentEntryPasses">Print Student Entry Passes</label>

		<input id="ShowTemplate_Default" name="ShowTemplate_Default" type="checkbox" class="CHK" [(ngModel)]="ShowTemplate_Default" />
		<label for="ShowTemplate_Default">Default Visitor Pass Template</label>

		<input
			id="ShowTemplate_VerificationReqd"
			name="ShowTemplate_VerificationReqd"
			type="checkbox"
			class="CHK"
			[(ngModel)]="ShowTemplate_VerificationReqd"
		/>
		<label for="ShowTemplate_VerificationReqd">Verification Required Pass Template</label>

		<input id="ShowTemplate_OffenderHit" name="ShowTemplate_OffenderHit" type="checkbox" class="CHK" [(ngModel)]="ShowTemplate_OffenderHit" />
		<label for="ShowTemplate_OffenderHit">Offender Hit Pass Template</label>

		<input id="ShowSelfCheckInVerifyText" name="ShowSelfCheckInVerifyText" type="checkbox" class="CHK" [(ngModel)]="ShowSelfCheckInVerifyText" />
		<label for="ShowSelfCheckInVerifyText">Self Check In Text</label>

		<input id="ShowKeyboardMode" name="ShowKeyboardMode" type="checkbox" class="CHK" [(ngModel)]="ShowKeyboardMode" />
		<label for="ShowKeyboardMode">Keyboard Mode</label>

		<input id="ShowStationMode" name="ShowStationMode" type="checkbox" class="CHK" [(ngModel)]="ShowStationMode" />
		<label for="ShowStationMode">Station Mode</label>

		<input id="ShowHas2DScanner" name="ShowHas2DScanner" type="checkbox" class="CHK" [(ngModel)]="ShowHas2DScanner" />
		<label for="ShowHas2DScanner">Using 2D Barcode Reader</label>

		<input id="ShowHasSingleSidedScanner" name="ShowHasSingleSidedScanner" type="checkbox" class="CHK" [(ngModel)]="ShowHasSingleSidedScanner" />
		<label for="ShowHasSingleSidedScanner">Using Single-Sided Card Scanner</label>

		<input id="ShowHasDoubleSidedScanner" name="ShowHasDoubleSidedScanner" type="checkbox" class="CHK" [(ngModel)]="ShowHasDoubleSidedScanner" />
		<label for="ShowHasDoubleSidedScanner">Using Double-Sided Card Scanner</label>

		<input id="ShowHasRFIDReader" name="ShowHasRFIDReader" type="checkbox" class="CHK" [(ngModel)]="ShowHasRFIDReader" />
		<label for="ShowHasRFIDReader">Using RFID Tapper</label>

		<input id="ShowHasSignaturePad" name="ShowHasSignaturePad" type="checkbox" class="CHK" [(ngModel)]="ShowHasSignaturePad" />
		<label for="ShowHasSignaturePad">Using Signature Pad</label>

		<input id="ShowWebcamDeviceName" name="ShowWebcamDeviceName" type="checkbox" class="CHK" [(ngModel)]="ShowWebcamDeviceName" />
		<label for="ShowWebcamDeviceName">Webcam</label>

		<input id="ShowVisitorScanCount" name="ShowVisitorScanCount" type="checkbox" class="CHK" [(ngModel)]="ShowVisitorScanCount" />
		<label for="ShowVisitorScanCount">Visitor Scan Count</label>

		<input id="ShowLastVisitorDT" name="ShowLastVisitorDT" type="checkbox" class="CHK" [(ngModel)]="ShowLastVisitorDT" />
		<label for="ShowLastVisitorDT">Last Visitor Scan</label>

		<input id="ShowLastLoginDT" name="ShowLastLoginDT" type="checkbox" class="CHK" [(ngModel)]="ShowLastLoginDT" />
		<label for="ShowLastLoginDT">Last Login</label>

		<input id="Showc_Date" name="Showc_Date" type="checkbox" class="CHK" [(ngModel)]="Showc_Date" />
		<label for="Showc_Date">Last Updated</label>

		<input id="ShowSyncDropdownMinutes" name="ShowSyncDropdownMinutes" type="checkbox" class="CHK" [(ngModel)]="ShowSyncDropdownMinutes" />
		<label for="ShowSyncDropdownMinutes">Sync Dropdown Minutes</label>

		<input id="ShowIsScanStation" name="ShowIsScanStation" type="checkbox" class="CHK" [(ngModel)]="ShowIsScanStation" />
		<label for="ShowIsScanStation">Running ScanStation</label>
	</div>

	<div style="display: grid">
		<button class="btn btn-warning" (click)="onResetOptions()">Reset Options</button>
		<button class="btn btn-warning" (click)="onDeselectAllOptions()">Deselect All</button>
		<button class="btn btn-primary" (click)="onShowModes()">Show Mode Settings</button>
		<button class="btn btn-primary" (click)="onShowSkipPages()">Show Skip Page Settings</button>
		<button class="btn btn-primary" (click)="onShowPanicButton()">Show Panic Button Settings</button>
		<button class="btn btn-primary" (click)="onShowPrinterSettings()">Show Printer Settings</button>
		<button class="btn btn-warning" (click)="onSelectAllOptions()">Select All</button>
		<button class="btn btn-primary" (click)="onRefresh()">Refresh Stations</button>
	</div>
</div>

<!--Main Table-->
<div>
	<p-table
		#mydt
		[value]="lstScanStation"
		[loading]="StationLoading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedScanStation"
		dataKey="ScanStationID"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--ScanStation-->
				<th *ngIf="ShowScanStation == true">
					<p-columnFilter type="text" field="ScanStation" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--CurrentVersion-->
				<th *ngIf="ShowCurrentVersion == true">
					<p-columnFilter field="CurrentVersion" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterCurrentVersion
								[ngModel]="value"
								[options]="lstCurrentVersion"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--OutOfDateDesc-->
				<th *ngIf="ShowOutOfDateDesc == true">
					<p-columnFilter field="OutOfDateDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterOutOfDateDesc
								[ngModel]="value"
								[options]="lstOutOfDateDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--FacilityID-->
				<th *ngIf="ShowFacilityID == true">
					<!-- <p-columnFilter type="text" field="FacilityID" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--FacilityLocationID-->
				<th *ngIf="ShowFacilityLocationID == true">
					<!-- <p-columnFilter type="text" field="FacilityLocationID" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--UseDefaultValues-->
				<th *ngIf="ShowUseDefaultValues == true">
					<p-columnFilter field="UseDefaultValuesDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterUseDefaultValuesDesc
								[ngModel]="value"
								[options]="lstUseDefaultValuesDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--VisitorModeEnabled-->
				<th *ngIf="ShowVisitorModeEnabled == true">
					<p-columnFilter field="VisitorModeEnabledDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterVisitorModeEnabledDesc
								[ngModel]="value"
								[options]="lstVisitorModeEnabledDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--StudentModeEnabled-->
				<th *ngIf="ShowStudentModeEnabled == true">
					<p-columnFilter field="StudentModeEnabledDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterStudentModeEnabledDesc
								[ngModel]="value"
								[options]="lstStudentModeEnabledDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--StaffModeEnabled-->
				<th *ngIf="ShowStaffModeEnabled == true">
					<p-columnFilter field="StaffModeEnabledDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterStaffModeEnabledDesc
								[ngModel]="value"
								[options]="lstStaffModeEnabledDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--OffenderLookupEnabled-->
				<th *ngIf="ShowOffenderLookupEnabled == true">
					<p-columnFilter field="OffenderLookupEnabledDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterOffenderLookupEnabledDesc
								[ngModel]="value"
								[options]="lstOffenderLookupEnabledDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--PanicButtonEnabled-->
				<th *ngIf="ShowPanicButtonEnabled == true">
					<p-columnFilter field="PanicButtonEnabledDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPanicButtonEnabledDesc
								[ngModel]="value"
								[options]="lstPanicButtonEnabledDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ConfirmPanicButtonEnabled-->
				<th *ngIf="ShowConfirmPanicButtonEnabled == true">
					<p-columnFilter field="ConfirmPanicButtonEnabledDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterConfirmPanicButtonEnabledDesc
								[ngModel]="value"
								[options]="lstConfirmPanicButtonEnabledDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--PanicButtonText-->
				<th *ngIf="ShowPanicButtonText == true">
					<p-columnFilter field="PanicButtonText" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPanicButtonText
								[ngModel]="value"
								[options]="lstPanicButtonText"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ConfirmPanicButtonText-->
				<th *ngIf="ShowConfirmPanicButtonText == true">
					<p-columnFilter field="ConfirmPanicButtonText" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterConfirmPanicButtonText
								[ngModel]="value"
								[options]="lstConfirmPanicButtonText"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--PanicButtonTopicID-->
				<th *ngIf="ShowPanicButtonTopicID == true">
					<!-- <p-columnFilter type="text" field="PanicButtonTopicID" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--SkipConfirmInfo-->
				<th *ngIf="ShowSkipConfirmInfo == true">
					<p-columnFilter field="SkipConfirmInfoDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSkipConfirmInfoDesc
								[ngModel]="value"
								[options]="lstSkipConfirmInfoDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--PhotoRequired-->
				<th *ngIf="ShowPhotoRequired == true">
					<p-columnFilter field="PhotoRequiredDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPhotoRequiredDesc
								[ngModel]="value"
								[options]="lstPhotoRequiredDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--SkipPhotoIfNotRequired-->
				<th *ngIf="ShowSkipPhotoIfNotRequired == true">
					<p-columnFilter field="SkipPhotoIfNotRequiredDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSkipPhotoIfNotRequiredDesc
								[ngModel]="value"
								[options]="lstSkipPhotoIfNotRequiredDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--UseDriversLicensePhoto-->
				<th *ngIf="ShowUseDriversLicensePhoto == true">
					<p-columnFilter field="UseDriversLicensePhotoDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterUseDriversLicensePhotoDesc
								[ngModel]="value"
								[options]="lstUseDriversLicensePhotoDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--AllowExistingPhoto-->
				<th *ngIf="ShowAllowExistingPhoto == true">
					<p-columnFilter field="AllowExistingPhotoDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterAllowExistingPhotoDesc
								[ngModel]="value"
								[options]="lstAllowExistingPhotoDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--ForceRetakePhotoAfterXDays-->
				<th *ngIf="ShowForceRetakePhotoAfterXDays == true">
					<p-columnFilter field="ForceRetakePhotoAfterXDays" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterForceRetakePhotoAfterXDays
								[ngModel]="value"
								[options]="lstForceRetakePhotoAfterXDays"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--SkipVisitorType-->
				<th *ngIf="ShowSkipVisitorType == true">
					<p-columnFilter field="SkipVisitorTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSkipVisitorTypeDesc
								[ngModel]="value"
								[options]="lstSkipVisitorTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--DefaultVisitorTypeID-->
				<th *ngIf="ShowDefaultVisitorTypeID == true">
					<!-- <p-columnFilter type="text" field="DefaultVisitorTypeID" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--SkipVisitee-->
				<th *ngIf="ShowSkipVisitee == true">
					<p-columnFilter field="SkipVisiteeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSkipVisiteeDesc
								[ngModel]="value"
								[options]="lstSkipVisiteeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--DefaultVisiteeID-->
				<th *ngIf="ShowDefaultVisiteeID == true">
					<!-- <p-columnFilter type="text" field="DefaultVisiteeID" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--SkipVisitReason-->
				<th *ngIf="ShowSkipVisitReason == true">
					<p-columnFilter field="SkipVisitReasonDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSkipVisitReasonDesc
								[ngModel]="value"
								[options]="lstSkipVisitReasonDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--DefaultVisitReasonID-->
				<th *ngIf="ShowDefaultVisitReasonID == true">
					<!-- <p-columnFilter type="text" field="DefaultVisitReasonID" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--SkipAdditionalNotes-->
				<th *ngIf="ShowSkipAdditionalNotes == true">
					<p-columnFilter field="SkipAdditionalNotesDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSkipAdditionalNotesDesc
								[ngModel]="value"
								[options]="lstSkipAdditionalNotesDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--SkipSignature-->
				<th *ngIf="ShowSkipSignature == true">
					<p-columnFilter field="SkipSignatureDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSkipSignatureDesc
								[ngModel]="value"
								[options]="lstSkipSignatureDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--UseDriversLicenseSignature-->
				<th *ngIf="ShowUseDriversLicenseSignature == true">
					<p-columnFilter field="UseDriversLicenseSignatureDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterUseDriversLicenseSignatureDesc
								[ngModel]="value"
								[options]="lstUseDriversLicenseSignatureDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--PrinterName-->
				<th *ngIf="ShowPrinterName == true">
					<p-columnFilter field="PrinterName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPrinterName
								[ngModel]="value"
								[options]="lstPrinterName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--PrinterAlignTop-->
				<th *ngIf="ShowPrinterAlignTop == true">
					<p-columnFilter field="PrinterAlignTop" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPrinterAlignTop
								[ngModel]="value"
								[options]="lstPrinterAlignTop"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--PrinterAlignLeft-->
				<th *ngIf="ShowPrinterAlignLeft == true">
					<p-columnFilter field="PrinterAlignLeft" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPrinterAlignLeft
								[ngModel]="value"
								[options]="lstPrinterAlignLeft"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--PrintStudentLatePasses-->
				<th *ngIf="ShowPrintStudentLatePasses == true">
					<p-columnFilter field="PrintStudentLatePassesDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPrintStudentLatePassesDesc
								[ngModel]="value"
								[options]="lstPrintStudentLatePassesDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--PrintStudentEntryPasses-->
				<th *ngIf="ShowPrintStudentEntryPasses == true">
					<p-columnFilter field="PrintStudentEntryPassesDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPrintStudentEntryPassesDesc
								[ngModel]="value"
								[options]="lstPrintStudentEntryPassesDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Template_Default-->
				<th *ngIf="ShowTemplate_Default == true">
					<!-- <p-columnFilter type="text" field="Template_Default" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--Template_VerificationReqd-->
				<th *ngIf="ShowTemplate_VerificationReqd == true">
					<!-- <p-columnFilter type="text" field="Template_VerificationReqd" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--Template_OffenderHit-->
				<th *ngIf="ShowTemplate_OffenderHit == true">
					<!-- <p-columnFilter type="text" field="Template_OffenderHit" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--SelfCheckInVerifyText-->
				<th *ngIf="ShowSelfCheckInVerifyText == true">
					<p-columnFilter field="SelfCheckInVerifyText" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSelfCheckInVerifyText
								[ngModel]="value"
								[options]="lstSelfCheckInVerifyText"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--KeyboardMode-->
				<th *ngIf="ShowKeyboardMode == true">
					<!-- <p-columnFilter type="text" field="KeyboardMode" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--StationMode-->
				<th *ngIf="ShowStationMode == true">
					<!-- <p-columnFilter type="text" field="StationMode" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--Has2DScanner-->
				<th *ngIf="ShowHas2DScanner == true">
					<p-columnFilter field="Has2DScannerDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterHas2DScannerDesc
								[ngModel]="value"
								[options]="lstHas2DScannerDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--HasSingleSidedScanner-->
				<th *ngIf="ShowHasSingleSidedScanner == true">
					<p-columnFilter field="HasSingleSidedScannerDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterHasSingleSidedScannerDesc
								[ngModel]="value"
								[options]="lstHasSingleSidedScannerDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--HasDoubleSidedScanner-->
				<th *ngIf="ShowHasDoubleSidedScanner == true">
					<p-columnFilter field="HasDoubleSidedScannerDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterHasDoubleSidedScannerDesc
								[ngModel]="value"
								[options]="lstHasDoubleSidedScannerDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--HasRFIDReader-->
				<th *ngIf="ShowHasRFIDReader == true">
					<p-columnFilter field="HasRFIDReaderDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterHasRFIDReaderDesc
								[ngModel]="value"
								[options]="lstHasRFIDReaderDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--HasSignaturePad-->
				<th *ngIf="ShowHasSignaturePad == true">
					<p-columnFilter field="HasSignaturePadDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterHasSignaturePadDesc
								[ngModel]="value"
								[options]="lstHasSignaturePadDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--WebcamDeviceName-->
				<th *ngIf="ShowWebcamDeviceName == true">
					<p-columnFilter field="WebcamDeviceName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterWebcamDeviceName
								[ngModel]="value"
								[options]="lstWebcamDeviceName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--VisitorScanCount-->
				<th *ngIf="ShowVisitorScanCount == true">
					<!-- <p-columnFilter type="text" field="VisitorScanCount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--LastVisitorDT-->
				<th *ngIf="ShowLastVisitorDT == true">
					<!-- <p-columnFilter type="text" field="LastVisitorDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--LastLoginDT-->
				<th *ngIf="ShowLastLoginDT == true">
					<!-- <p-columnFilter type="text" field="LastLoginDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--c_Date-->
				<th *ngIf="Showc_Date == true">
					<!-- <p-columnFilter type="text" field="c_Date" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--SyncDropdownMinutes-->
				<th *ngIf="ShowSyncDropdownMinutes == true">
					<!-- <p-columnFilter type="text" field="SyncDropdownMinutes" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--IsScanStation-->
				<th *ngIf="ShowIsScanStation == true">
					<p-columnFilter field="IsScanStationDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterIsScanStationDesc
								[ngModel]="value"
								[options]="lstIsScanStationDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th></th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th *ngIf="ShowScanStation == true" pSortableColumn="ScanStation">Station<p-sortIcon field="ScanStation"></p-sortIcon></th>
				<th *ngIf="ShowCurrentVersion == true" pSortableColumn="CurrentVersion">Version<p-sortIcon field="CurrentVersion"></p-sortIcon></th>
				<th *ngIf="ShowOutOfDateDesc == true" pSortableColumn="OutOfDateDesc">Out of Date<p-sortIcon field="OutOfDateDesc"></p-sortIcon></th>
				<th *ngIf="ShowFacilityID == true" pSortableColumn="FacilityID">Facility<p-sortIcon field="FacilityID"></p-sortIcon></th>
				<th *ngIf="ShowFacilityLocationID == true" pSortableColumn="FacilityLocationID">
					Location<p-sortIcon field="FacilityLocationID"></p-sortIcon>
				</th>
				<th *ngIf="ShowUseDefaultValues == true" pSortableColumn="UseDefaultValues">
					Use Default Values<p-sortIcon field="UseDefaultValues"></p-sortIcon>
				</th>
				<th *ngIf="ShowVisitorModeEnabled == true" pSortableColumn="VisitorModeEnabled">
					Visitor Scanning Enabled<p-sortIcon field="VisitorModeEnabled"></p-sortIcon>
				</th>
				<th *ngIf="ShowStudentModeEnabled == true" pSortableColumn="StudentModeEnabled">
					Student Scanning Enabled<p-sortIcon field="StudentModeEnabled"></p-sortIcon>
				</th>
				<th *ngIf="ShowStaffModeEnabled == true" pSortableColumn="StaffModeEnabled">
					Staff Scanning Enabled<p-sortIcon field="StaffModeEnabled"></p-sortIcon>
				</th>
				<th *ngIf="ShowOffenderLookupEnabled == true" pSortableColumn="OffenderLookupEnabled">
					Offender Lookup Enabled<p-sortIcon field="OffenderLookupEnabled"></p-sortIcon>
				</th>
				<th *ngIf="ShowPanicButtonEnabled == true" pSortableColumn="PanicButtonEnabled">
					Panic Button Enabled<p-sortIcon field="PanicButtonEnabled"></p-sortIcon>
				</th>
				<th *ngIf="ShowConfirmPanicButtonEnabled == true" pSortableColumn="ConfirmPanicButtonEnabled">
					Confirm Panic Button Enabled<p-sortIcon field="ConfirmPanicButtonEnabled"></p-sortIcon>
				</th>
				<th *ngIf="ShowPanicButtonText == true" pSortableColumn="PanicButtonText">
					Panic Button Text<p-sortIcon field="PanicButtonText"></p-sortIcon>
				</th>
				<th *ngIf="ShowConfirmPanicButtonText == true" pSortableColumn="ConfirmPanicButtonText">
					Confirm Panic Button Text<p-sortIcon field="ConfirmPanicButtonText"></p-sortIcon>
				</th>
				<th *ngIf="ShowPanicButtonTopicID == true" pSortableColumn="PanicButtonTopicID">
					Panic Button Topic (Staff App)<p-sortIcon field="PanicButtonTopicID"></p-sortIcon>
				</th>
				<th *ngIf="ShowSkipConfirmInfo == true" pSortableColumn="SkipConfirmInfo">
					Skip Confirm Info Page<p-sortIcon field="SkipConfirmInfo"></p-sortIcon>
				</th>
				<th *ngIf="ShowPhotoRequired == true" pSortableColumn="PhotoRequired">Photo Required<p-sortIcon field="PhotoRequired"></p-sortIcon></th>
				<th *ngIf="ShowSkipPhotoIfNotRequired == true" pSortableColumn="SkipPhotoIfNotRequired">
					Skip Photo Page If Not Required<p-sortIcon field="SkipPhotoIfNotRequired"></p-sortIcon>
				</th>
				<th *ngIf="ShowUseDriversLicensePhoto == true" pSortableColumn="UseDriversLicensePhoto">
					Use Driver's License Photo<p-sortIcon field="UseDriversLicensePhoto"></p-sortIcon>
				</th>
				<th *ngIf="ShowAllowExistingPhoto == true" pSortableColumn="AllowExistingPhoto">
					Allow Existing Photo<p-sortIcon field="AllowExistingPhoto"></p-sortIcon>
				</th>
				<th *ngIf="ShowForceRetakePhotoAfterXDays == true" pSortableColumn="ForceRetakePhotoAfterXDays">
					Retake Existing Photo After X Days<p-sortIcon field="ForceRetakePhotoAfterXDays"></p-sortIcon>
				</th>
				<th *ngIf="ShowSkipVisitorType == true" pSortableColumn="SkipVisitorType">
					Skip Visitor Type Page<p-sortIcon field="SkipVisitorType"></p-sortIcon>
				</th>
				<th *ngIf="ShowDefaultVisitorTypeID == true" pSortableColumn="DefaultVisitorTypeID">
					Default Visitor Type (If Skipping)<p-sortIcon field="DefaultVisitorTypeID"></p-sortIcon>
				</th>
				<th *ngIf="ShowSkipVisitee == true" pSortableColumn="SkipVisitee">Skip Visitee Page<p-sortIcon field="SkipVisitee"></p-sortIcon></th>
				<th *ngIf="ShowDefaultVisiteeID == true" pSortableColumn="DefaultVisiteeID">
					Default Visitee (If Skipping)<p-sortIcon field="DefaultVisiteeID"></p-sortIcon>
				</th>
				<th *ngIf="ShowSkipVisitReason == true" pSortableColumn="SkipVisitReason">
					Skip Visit Reason Page<p-sortIcon field="SkipVisitReason"></p-sortIcon>
				</th>
				<th *ngIf="ShowDefaultVisitReasonID == true" pSortableColumn="DefaultVisitReasonID">
					Default Visit Reason (If Skipping)<p-sortIcon field="DefaultVisitReasonID"></p-sortIcon>
				</th>
				<th *ngIf="ShowSkipAdditionalNotes == true" pSortableColumn="SkipAdditionalNotes">
					Skip Additional Notes Page<p-sortIcon field="SkipAdditionalNotes"></p-sortIcon>
				</th>
				<th *ngIf="ShowSkipSignature == true" pSortableColumn="SkipSignature">Skip Signature Page<p-sortIcon field="SkipSignature"></p-sortIcon></th>
				<th *ngIf="ShowUseDriversLicenseSignature == true" pSortableColumn="UseDriversLicenseSignature">
					Use Driver's License Signature<p-sortIcon field="UseDriversLicenseSignature"></p-sortIcon>
				</th>
				<th *ngIf="ShowPrinterName == true" pSortableColumn="PrinterName">Printer Name<p-sortIcon field="PrinterName"></p-sortIcon></th>
				<th *ngIf="ShowPrinterAlignTop == true" pSortableColumn="PrinterAlignTop">
					Printer Align Top<p-sortIcon field="PrinterAlignTop"></p-sortIcon>
				</th>
				<th *ngIf="ShowPrinterAlignLeft == true" pSortableColumn="PrinterAlignLeft">
					Printer Align Left<p-sortIcon field="PrinterAlignLeft"></p-sortIcon>
				</th>
				<th *ngIf="ShowPrintStudentLatePasses == true" pSortableColumn="PrintStudentLatePasses">
					Print Student Late Passes<p-sortIcon field="PrintStudentLatePasses"></p-sortIcon>
				</th>
				<th *ngIf="ShowPrintStudentEntryPasses == true" pSortableColumn="PrintStudentEntryPasses">
					Print Student Entry Passes<p-sortIcon field="PrintStudentEntryPasses"></p-sortIcon>
				</th>
				<th *ngIf="ShowTemplate_Default == true" pSortableColumn="Template_Default">
					Default Visitor Pass Template<p-sortIcon field="Template_Default"></p-sortIcon>
				</th>
				<th *ngIf="ShowTemplate_VerificationReqd == true" pSortableColumn="Template_VerificationReqd">
					Verification Required Pass Template<p-sortIcon field="Template_VerificationReqd"></p-sortIcon>
				</th>
				<th *ngIf="ShowTemplate_OffenderHit == true" pSortableColumn="Template_OffenderHit">
					Offender Hit Pass Template<p-sortIcon field="Template_OffenderHit"></p-sortIcon>
				</th>
				<th *ngIf="ShowSelfCheckInVerifyText == true" pSortableColumn="SelfCheckInVerifyText">
					Self Check In Text<p-sortIcon field="SelfCheckInVerifyText"></p-sortIcon>
				</th>
				<th *ngIf="ShowKeyboardMode == true" pSortableColumn="KeyboardMode">Keyboard Mode<p-sortIcon field="KeyboardMode"></p-sortIcon></th>
				<th *ngIf="ShowStationMode == true" pSortableColumn="StationMode">Station Mode<p-sortIcon field="StationMode"></p-sortIcon></th>
				<th *ngIf="ShowHas2DScanner == true" pSortableColumn="Has2DScanner">Using 2D Barcode Reader<p-sortIcon field="Has2DScanner"></p-sortIcon></th>
				<th *ngIf="ShowHasSingleSidedScanner == true" pSortableColumn="HasSingleSidedScanner">
					Using Single-Sided Card Scanner<p-sortIcon field="HasSingleSidedScanner"></p-sortIcon>
				</th>
				<th *ngIf="ShowHasDoubleSidedScanner == true" pSortableColumn="HasDoubleSidedScanner">
					Using Double-Sided Card Scanner<p-sortIcon field="HasDoubleSidedScanner"></p-sortIcon>
				</th>
				<th *ngIf="ShowHasRFIDReader == true" pSortableColumn="HasRFIDReader">Using RFID Tapper<p-sortIcon field="HasRFIDReader"></p-sortIcon></th>
				<th *ngIf="ShowHasSignaturePad == true" pSortableColumn="HasSignaturePad">
					Using Signature Pad<p-sortIcon field="HasSignaturePad"></p-sortIcon>
				</th>
				<th *ngIf="ShowWebcamDeviceName == true" pSortableColumn="WebcamDeviceName">Webcam<p-sortIcon field="WebcamDeviceName"></p-sortIcon></th>
				<th *ngIf="ShowVisitorScanCount == true" pSortableColumn="VisitorScanCount">
					Visitor Scan Count<p-sortIcon field="VisitorScanCount"></p-sortIcon>
				</th>
				<th *ngIf="ShowLastVisitorDT == true" pSortableColumn="LastVisitorDT">Last Visitor Scan<p-sortIcon field="LastVisitorDT"></p-sortIcon></th>
				<th *ngIf="ShowLastLoginDT == true" pSortableColumn="LastLoginDT">Last Login<p-sortIcon field="LastLoginDT"></p-sortIcon></th>
				<th *ngIf="Showc_Date == true" pSortableColumn="c_Date">Last Updated<p-sortIcon field="c_Date"></p-sortIcon></th>
				<th *ngIf="ShowSyncDropdownMinutes == true" pSortableColumn="SyncDropdownMinutes">
					Sync Dropdown Minutes<p-sortIcon field="SyncDropdownMinutes"></p-sortIcon>
				</th>
				<th *ngIf="ShowIsScanStation == true" pSortableColumn="IsScanStation">Running ScanStation<p-sortIcon field="IsScanStation"></p-sortIcon></th>
				<th></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-ScanStation>
			<tr [pSelectableRow]="ScanStation" (dblclick)="onRowDblClick(ScanStation)">
				<td *ngIf="ShowScanStation == true">
					<div class="TableTD">
						{{ ScanStation.ScanStation }}
					</div>
				</td>
				<td *ngIf="ShowCurrentVersion == true">
					<div class="TableTD" [style.color]="ScanStation.OutOfDate == false ? 'Black' : 'Red'">
						{{ ScanStation.CurrentVersion }}
					</div>
				</td>
				<td *ngIf="ShowOutOfDateDesc == true">
					<div class="TableTD" [style.color]="ScanStation.OutOfDate == false ? 'Black' : 'Red'">
						{{ ScanStation.OutOfDateDesc }}
					</div>
				</td>
				<td *ngIf="ShowFacilityID == true">
					<div class="TableTD">
						<select
							[disabled]="IsLoading() == true"
							class="form-control"
							name="ScanStation.FacilityID"
							[(ngModel)]="ScanStation.FacilityID"
							(ngModelChange)="onScanStationFacilityChange($event, ScanStation)"
						>
							<option value="" style="display: none"></option>
							<option *ngFor="let o of lstAllFacility" [ngValue]="o.FacilityID">{{ o.FacilityName }}</option>
						</select>
					</div>
				</td>
				<td *ngIf="ShowFacilityLocationID == true">
					<div class="TableTD">
						<select
							[disabled]="IsLoading() == true || ScanStation.FacilityLocationLoading == true"
							class="form-control"
							name="ScanStation.FacilityLocationID"
							[(ngModel)]="ScanStation.FacilityLocationID"
						>
							<option value="" style="display: none"></option>
							<option *ngFor="let o of ScanStation.lstFacilityLocation" [ngValue]="o.ID">{{ o.Desc }}</option>
						</select>
					</div>
				</td>
				<td *ngIf="ShowUseDefaultValues == true">
					<div class="TableTD">
						<input [disabled]="IsLoading() == true" type="checkbox" class="CHK" [(ngModel)]="ScanStation.UseDefaultValues" />
					</div>
				</td>
				<td *ngIf="ShowVisitorModeEnabled == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.VisitorModeEnabledLockLevel > 0"
							type="checkbox"
							class="CHK"
							[(ngModel)]="ScanStation.VisitorModeEnabled"
						/>

						<label *ngIf="ScanStation.VisitorModeEnabledLockLevel == 1 || ScanStation.VisitorModeEnabledLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.VisitorModeEnabledLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.VisitorModeEnabledLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowStudentModeEnabled == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.StudentModeEnabledLockLevel > 0"
							type="checkbox"
							class="CHK"
							[(ngModel)]="ScanStation.StudentModeEnabled"
						/>

						<label *ngIf="ScanStation.StudentModeEnabledLockLevel == 1 || ScanStation.StudentModeEnabledLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.StudentModeEnabledLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.StudentModeEnabledLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowStaffModeEnabled == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.StaffModeEnabledLockLevel > 0"
							type="checkbox"
							class="CHK"
							[(ngModel)]="ScanStation.StaffModeEnabled"
						/>

						<label *ngIf="ScanStation.StaffModeEnabledLockLevel == 1 || ScanStation.StaffModeEnabledLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.StaffModeEnabledLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.StaffModeEnabledLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowOffenderLookupEnabled == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.OffenderLookupEnabledLockLevel > 0"
							type="checkbox"
							class="CHK"
							[(ngModel)]="ScanStation.OffenderLookupEnabled"
						/>

						<label *ngIf="ScanStation.OffenderLookupEnabledLockLevel == 1 || ScanStation.OffenderLookupEnabledLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.OffenderLookupEnabledLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.OffenderLookupEnabledLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowPanicButtonEnabled == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.PanicButtonEnabledLockLevel > 0"
							type="checkbox"
							class="CHK"
							[(ngModel)]="ScanStation.PanicButtonEnabled"
						/>

						<label *ngIf="ScanStation.PanicButtonEnabledLockLevel == 1 || ScanStation.PanicButtonEnabledLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.PanicButtonEnabledLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.PanicButtonEnabledLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowConfirmPanicButtonEnabled == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.ConfirmPanicButtonEnabledLockLevel > 0"
							type="checkbox"
							class="CHK"
							[(ngModel)]="ScanStation.ConfirmPanicButtonEnabled"
						/>

						<label
							*ngIf="ScanStation.ConfirmPanicButtonEnabledLockLevel == 1 || ScanStation.ConfirmPanicButtonEnabledLockLevel == 3"
							class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.ConfirmPanicButtonEnabledLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.ConfirmPanicButtonEnabledLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowPanicButtonText == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.PanicButtonTextLockLevel > 0"
							type="text"
							class="form-control"
							[(ngModel)]="ScanStation.PanicButtonText"
						/>

						<label *ngIf="ScanStation.PanicButtonTextLockLevel == 1 || ScanStation.PanicButtonTextLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.PanicButtonTextLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.PanicButtonTextLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowConfirmPanicButtonText == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.ConfirmPanicButtonTextLockLevel > 0"
							type="text"
							class="form-control"
							[(ngModel)]="ScanStation.ConfirmPanicButtonText"
						/>

						<label *ngIf="ScanStation.ConfirmPanicButtonTextLockLevel == 1 || ScanStation.ConfirmPanicButtonTextLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.ConfirmPanicButtonTextLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.ConfirmPanicButtonTextLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowPanicButtonTopicID == true">
					<div class="TableTD">
						<select
							[disabled]="IsLoading() == true || ScanStation.PanicButtonTopicLockLevel > 0 || ScanStation.PanicButtonTopicLoading == true"
							class="form-control"
							name="ScanStation.PanicButtonTopicID"
							[(ngModel)]="ScanStation.PanicButtonTopicID"
						>
							<option value="" style="display: none"></option>
							<option *ngFor="let o of ScanStation.lstPanicButtonTopic" [ngValue]="o.ID">{{ o.Desc }}</option>
						</select>

						<label *ngIf="ScanStation.PanicButtonTopicLockLevel == 1 || ScanStation.PanicButtonTopicLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.PanicButtonTopicLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.PanicButtonTopicLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowSkipConfirmInfo == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.SkipConfirmInfoLockLevel > 0"
							type="checkbox"
							class="CHK"
							[(ngModel)]="ScanStation.SkipConfirmInfo"
						/>

						<label *ngIf="ScanStation.SkipConfirmInfoLockLevel == 1 || ScanStation.SkipConfirmInfoLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.SkipConfirmInfoLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.SkipConfirmInfoLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowPhotoRequired == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.PhotoRequiredLockLevel > 0"
							type="checkbox"
							class="CHK"
							[(ngModel)]="ScanStation.PhotoRequired"
						/>

						<label *ngIf="ScanStation.PhotoRequiredLockLevel == 1 || ScanStation.PhotoRequiredLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.PhotoRequiredLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.PhotoRequiredLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowSkipPhotoIfNotRequired == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.SkipPhotoIfNotRequiredLockLevel > 0"
							type="checkbox"
							class="CHK"
							[(ngModel)]="ScanStation.SkipPhotoIfNotRequired"
						/>

						<label *ngIf="ScanStation.SkipPhotoIfNotRequiredLockLevel == 1 || ScanStation.SkipPhotoIfNotRequiredLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.SkipPhotoIfNotRequiredLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.SkipPhotoIfNotRequiredLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowUseDriversLicensePhoto == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.UseDriversLicensePhotoLockLevel > 0"
							type="checkbox"
							class="CHK"
							[(ngModel)]="ScanStation.UseDriversLicensePhoto"
						/>

						<label *ngIf="ScanStation.UseDriversLicensePhotoLockLevel == 1 || ScanStation.UseDriversLicensePhotoLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.UseDriversLicensePhotoLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.UseDriversLicensePhotoLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowAllowExistingPhoto == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.AllowExistingPhotoLockLevel > 0"
							type="checkbox"
							class="CHK"
							[(ngModel)]="ScanStation.AllowExistingPhoto"
						/>

						<label *ngIf="ScanStation.AllowExistingPhotoLockLevel == 1 || ScanStation.AllowExistingPhotoLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.AllowExistingPhotoLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.AllowExistingPhotoLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowForceRetakePhotoAfterXDays == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.ForceRetakePhotoLockLevel > 0"
							type="number"
							min="0"
							class="form-control"
							[(ngModel)]="ScanStation.ForceRetakePhotoAfterXDays"
						/>

						<label *ngIf="ScanStation.ForceRetakePhotoLockLevel == 1 || ScanStation.ForceRetakePhotoLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.ForceRetakePhotoLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.ForceRetakePhotoLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowSkipVisitorType == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.SkipVisitorTypeLockLevel > 0"
							type="checkbox"
							class="CHK"
							[(ngModel)]="ScanStation.SkipVisitorType"
						/>

						<label *ngIf="ScanStation.SkipVisitorTypeLockLevel == 1 || ScanStation.SkipVisitorTypeLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.SkipVisitorTypeLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.SkipVisitorTypeLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowDefaultVisitorTypeID == true">
					<div class="TableTD">
						<select
							[disabled]="IsLoading() == true || ScanStation.DefaultVisitorTypeLockLevel > 0"
							class="form-control"
							name="ScanStation.DefaultVisitorTypeID"
							[(ngModel)]="ScanStation.DefaultVisitorTypeID"
						>
							<option value="" style="display: none"></option>
							<option *ngFor="let o of lstVisitorType" [ngValue]="o.ID">{{ o.Desc }}</option>
						</select>

						<label *ngIf="ScanStation.DefaultVisitorTypeLockLevel == 1 || ScanStation.DefaultVisitorTypeLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.DefaultVisitorTypeLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.DefaultVisitorTypeLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowSkipVisitee == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.SkipVisiteeLockLevel > 0"
							type="checkbox"
							class="CHK"
							[(ngModel)]="ScanStation.SkipVisitee"
						/>

						<label *ngIf="ScanStation.SkipVisiteeLockLevel == 1 || ScanStation.SkipVisiteeLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.SkipVisiteeLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.SkipVisiteeLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowDefaultVisiteeID == true">
					<div class="TableTD">
						<select
							[disabled]="IsLoading() == true || ScanStation.DefaultVisiteeLockLevel > 0 || ScanStation.VisiteeLoading == true"
							class="form-control"
							name="ScanStation.PanicButtonTopicID"
							[(ngModel)]="ScanStation.SelectedVisitee"
						>
							<option value="" style="display: none"></option>
							<option *ngFor="let o of ScanStation.lstVisitee" [ngValue]="o">{{ o.Desc }}</option>
						</select>

						<label *ngIf="ScanStation.DefaultVisiteeLockLevel == 1 || ScanStation.DefaultVisiteeLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.DefaultVisiteeLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.DefaultVisiteeLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowSkipVisitReason == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.SkipVisitReasonLockLevel > 0"
							type="checkbox"
							class="CHK"
							[(ngModel)]="ScanStation.SkipVisitReason"
						/>

						<label *ngIf="ScanStation.SkipVisitReasonLockLevel == 1 || ScanStation.SkipVisitReasonLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.SkipVisitReasonLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.SkipVisitReasonLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowDefaultVisitReasonID == true">
					<div class="TableTD">
						<select
							[disabled]="IsLoading() == true || ScanStation.DefaultVisitReasonLockLevel > 0"
							class="form-control"
							name="ScanStation.DefaultVisitReasonID"
							[(ngModel)]="ScanStation.DefaultVisitReasonID"
						>
							<option value="" style="display: none"></option>
							<option *ngFor="let o of lstVisitReason" [ngValue]="o.ID">{{ o.Desc }}</option>
						</select>

						<label *ngIf="ScanStation.DefaultVisitReasonLockLevel == 1 || ScanStation.DefaultVisitReasonLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.DefaultVisitReasonLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.DefaultVisitReasonLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowSkipAdditionalNotes == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.SkipAdditionalNotesLockLevel > 0"
							type="checkbox"
							class="CHK"
							[(ngModel)]="ScanStation.SkipAdditionalNotes"
						/>

						<label *ngIf="ScanStation.SkipAdditionalNotesLockLevel == 1 || ScanStation.SkipAdditionalNotesLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.SkipAdditionalNotesLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.SkipAdditionalNotesLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowSkipSignature == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.SkipSignatureLockLevel > 0"
							type="checkbox"
							class="CHK"
							[(ngModel)]="ScanStation.SkipSignature"
						/>

						<label *ngIf="ScanStation.SkipSignatureLockLevel == 1 || ScanStation.SkipSignatureLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.SkipSignatureLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.SkipSignatureLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowUseDriversLicenseSignature == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.UseDriversLicenseSignatureLockLevel > 0"
							type="checkbox"
							class="CHK"
							[(ngModel)]="ScanStation.UseDriversLicenseSignature"
						/>

						<label
							*ngIf="ScanStation.UseDriversLicenseSignatureLockLevel == 1 || ScanStation.UseDriversLicenseSignatureLockLevel == 3"
							class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.UseDriversLicenseSignatureLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.UseDriversLicenseSignatureLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowPrinterName == true">
					<div class="TableTD">
						{{ ScanStation.PrinterName }}
					</div>
				</td>
				<td *ngIf="ShowPrinterAlignTop == true">
					<div class="TableTD">
						<input [disabled]="IsLoading() == true" type="number" class="form-control" [(ngModel)]="ScanStation.PrinterAlignTop" />
					</div>
				</td>
				<td *ngIf="ShowPrinterAlignLeft == true">
					<div class="TableTD">
						<input [disabled]="IsLoading() == true" type="number" class="form-control" [(ngModel)]="ScanStation.PrinterAlignLeft" />
					</div>
				</td>
				<td *ngIf="ShowPrintStudentLatePasses == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.PrintStudentLatePassesLockLevel > 0"
							type="checkbox"
							class="CHK"
							[(ngModel)]="ScanStation.PrintStudentLatePasses"
						/>

						<label *ngIf="ScanStation.PrintStudentLatePassesLockLevel == 1 || ScanStation.PrintStudentLatePassesLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.PrintStudentLatePassesLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.PrintStudentLatePassesLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowPrintStudentEntryPasses == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.PrintStudentEntryPassesLockLevel > 0"
							type="checkbox"
							class="CHK"
							[(ngModel)]="ScanStation.PrintStudentEntryPasses"
						/>

						<label *ngIf="ScanStation.PrintStudentEntryPassesLockLevel == 1 || ScanStation.PrintStudentEntryPassesLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.PrintStudentEntryPassesLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.PrintStudentEntryPassesLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowTemplate_Default == true">
					<div class="TableTD">
						<select
							[disabled]="IsLoading() == true || ScanStation.Template_DefaultLockLevel > 0 || ScanStation.IDCardTemplateLoading == true"
							class="form-control"
							name="ScanStation.Template_Default"
							[(ngModel)]="ScanStation.Template_Default"
						>
							<option value="" style="display: none"></option>
							<option *ngFor="let o of ScanStation.lstIDCardTemplate" [ngValue]="o.IDCardTemplateID">{{ o.CardName }}</option>
						</select>

						<label *ngIf="ScanStation.Template_DefaultLockLevel == 1 || ScanStation.Template_DefaultLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.Template_DefaultLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.Template_DefaultLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowTemplate_VerificationReqd == true">
					<div class="TableTD">
						<select
							[disabled]="IsLoading() == true || ScanStation.Template_VerificationReqdLockLevel > 0 || ScanStation.IDCardTemplateLoading == true"
							class="form-control"
							name="ScanStation.Template_VerificationReqd"
							[(ngModel)]="ScanStation.Template_VerificationReqd"
						>
							<option value="" style="display: none"></option>
							<option *ngFor="let o of ScanStation.lstIDCardTemplate" [ngValue]="o.IDCardTemplateID">{{ o.CardName }}</option>
						</select>

						<label
							*ngIf="ScanStation.Template_VerificationReqdLockLevel == 1 || ScanStation.Template_VerificationReqdLockLevel == 3"
							class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.Template_VerificationReqdLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.Template_VerificationReqdLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowTemplate_OffenderHit == true">
					<div class="TableTD">
						<select
							[disabled]="IsLoading() == true || ScanStation.Template_OffenderHitLockLevel > 0 || ScanStation.IDCardTemplateLoading == true"
							class="form-control"
							name="ScanStation.Template_OffenderHit"
							[(ngModel)]="ScanStation.Template_OffenderHit"
						>
							<option value="" style="display: none"></option>
							<option *ngFor="let o of ScanStation.lstIDCardTemplate" [ngValue]="o.IDCardTemplateID">{{ o.CardName }}</option>
						</select>

						<label *ngIf="ScanStation.Template_OffenderHitLockLevel == 1 || ScanStation.Template_OffenderHitLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.Template_OffenderHitLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.Template_OffenderHitLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowSelfCheckInVerifyText == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.SelfCheckInVerifyTextLockLevel > 0"
							type="text"
							class="form-control"
							[(ngModel)]="ScanStation.SelfCheckInVerifyText"
						/>

						<label *ngIf="ScanStation.SelfCheckInVerifyTextLockLevel == 1 || ScanStation.SelfCheckInVerifyTextLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.SelfCheckInVerifyTextLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.SelfCheckInVerifyTextLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowKeyboardMode == true">
					<div class="TableTD">
						<select [disabled]="IsLoading() == true" class="form-control" name="ScanStation.KeyboardMode" [(ngModel)]="ScanStation.KeyboardMode">
							<option value="" style="display: none"></option>
							<option *ngFor="let o of lstKeyboardMode" [ngValue]="o.ID">{{ o.Desc }}</option>
						</select>
					</div>
				</td>
				<td *ngIf="ShowStationMode == true">
					<div class="TableTD">
						<select
							[disabled]="IsLoading() == true || ScanStation.StationModeLockLevel > 0"
							class="form-control"
							name="ScanStation.StationMode"
							[(ngModel)]="ScanStation.StationMode"
						>
							<option value="" style="display: none"></option>
							<option *ngFor="let o of lstStationMode" [ngValue]="o.ID">{{ o.Desc }}</option>
						</select>

						<label *ngIf="ScanStation.StationModeLockLevel == 1 || ScanStation.StationModeLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.StationModeLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.StationModeLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowHas2DScanner == true">
					<div class="TableTD">
						<i *ngIf="ScanStation.Has2DScanner == true" class="pi pi-check-circle table-active"></i>
						<i *ngIf="ScanStation.Has2DScanner == false" class="pi pi-ban table-inactive"></i>
					</div>
				</td>
				<td *ngIf="ShowHasSingleSidedScanner == true">
					<div class="TableTD">
						<i *ngIf="ScanStation.HasSingleSidedScanner == true" class="pi pi-check-circle table-active"></i>
						<i *ngIf="ScanStation.HasSingleSidedScanner == false" class="pi pi-ban table-inactive"></i>
					</div>
				</td>
				<td *ngIf="ShowHasDoubleSidedScanner == true">
					<div class="TableTD">
						<i *ngIf="ScanStation.HasDoubleSidedScanner == true" class="pi pi-check-circle table-active"></i>
						<i *ngIf="ScanStation.HasDoubleSidedScanner == false" class="pi pi-ban table-inactive"></i>
					</div>
				</td>
				<td *ngIf="ShowHasRFIDReader == true">
					<div class="TableTD">
						<i *ngIf="ScanStation.HasRFIDReader == true" class="pi pi-check-circle table-active"></i>
						<i *ngIf="ScanStation.HasRFIDReader == false" class="pi pi-ban table-inactive"></i>
					</div>
				</td>
				<td *ngIf="ShowHasSignaturePad == true">
					<div class="TableTD">
						<i *ngIf="ScanStation.HasSignaturePad == true" class="pi pi-check-circle table-active"></i>
						<i *ngIf="ScanStation.HasSignaturePad == false" class="pi pi-ban table-inactive"></i>
					</div>
				</td>
				<td *ngIf="ShowWebcamDeviceName == true">
					<div class="TableTD">
						{{ ScanStation.WebcamDeviceName }}
					</div>
				</td>
				<td *ngIf="ShowVisitorScanCount == true">
					<div class="TableTD">
						{{ ScanStation.VisitorScanCount }}
					</div>
				</td>
				<td *ngIf="ShowLastVisitorDT == true">
					<div class="TableTD">
						{{ ScanStation.LastVisitorDTDesc }}
					</div>
				</td>
				<td *ngIf="ShowLastLoginDT == true">
					<div class="TableTD">
						{{ ScanStation.LastLoginDTDesc }}
					</div>
				</td>
				<td *ngIf="Showc_Date == true">
					<div class="TableTD">
						{{ ScanStation.c_DateDesc }}
					</div>
				</td>
				<td *ngIf="ShowSyncDropdownMinutes == true">
					<div class="TableTD">
						<input
							[disabled]="IsLoading() == true || ScanStation.SyncDropdownMinutesLockLevel > 0"
							type="number"
							min="0"
							class="form-control"
							[(ngModel)]="ScanStation.SyncDropdownMinutes"
						/>

						<label *ngIf="ScanStation.SyncDropdownMinutesLockLevel == 1 || ScanStation.SyncDropdownMinutesLockLevel == 3" class="LockedText"
							>Locked by Access411</label
						>
						<label *ngIf="ScanStation.SyncDropdownMinutesLockLevel == 2" class="LockedText">Locked by District</label>
						<label *ngIf="ScanStation.SyncDropdownMinutesLockLevel == 4" class="LockedText">Locked by Facility</label>
					</div>
				</td>
				<td *ngIf="ShowIsScanStation == true">
					<div class="TableTD">
						{{ ScanStation.IsScanStationDesc }}
					</div>
				</td>
				<td>
					<button class="btn btn-success" (click)="onUpdateStation(ScanStation)">Update Settings</button>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
